module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v("Plan details")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/arrow-down-white.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "plan__detail"
  }, [_c('div', {
    staticClass: "font-24 font-weight-500 text-white"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 text-white my-3"
  }, [_vm._v("\n      This plan features 4 creators\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item plan__user mr-2 mb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-14 text-white"
    }, [_vm._v("@salva")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-12 text-grey-4"
    }, [_vm._v("ARTIST")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "my-3 mt-4 text-poppins-14 text-white"
  }, [_vm._v("\n      Exclusive drops from all my homies!\n    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-detail mx-0 text-white font-weight-500 full-width bg-black",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_vm._v("\n      Choose plan\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "font-20 font-weight-500 text-white"
  }, [_vm._v("20$/")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/you.png"),
      "width": "112",
      "height": "112"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-poppins-14 text-white mx-20"
  }, [_c('li', [_vm._v("10 exclusive tracks from 4 of the world famous electronic crews")]), _vm._v(" "), _c('li', [_vm._v("Stems for all tracks")]), _vm._v(" "), _c('li', [_vm._v("Vocal FXs")]), _vm._v(" "), _c('li', [_vm._v("VST presets for each track")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f35013ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/components/plan-detail/plan_detail.vue
// module id = 1869
// module chunks = 180